var Utilities = function(){
    return{
        currency: function(numberString) {
          var resultString = numberString + '',
              x = resultString.split('.'),
              x1 = x[0],
              x2 = x.length > 1 ? '.' + x[1] : '',
              rgxp = /(\d+)(\d{3})/;

          while (rgxp.test(x1)) {
            x1 = x1.replace(rgxp, '$1' + ',' + '$2');
          }

          return x1 + x2 + "";
        },
        currencyFormat: function(money){ //eg: 100,000.00
          money = numeral(money).format('0,0.00');
          return money;
        },
        formatNumber: function(money){//eg: 100,000
          money = numeral(money).format('0,0');
          return money;
        },
        numberFormatK: function(num) {
          if (num >= 1000000000) {
            return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
          }
          if (num >= 1000000) {
            return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
          }
          if (num >= 1000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
          }
          return num;
        },

        isExpired: function(expires_date){ //expires_date: YYYY/MM/DD HH:mm:ss
          let exps = moment(expires_date, "YYYY/MM/DD HH:mm:ss");
          let remain = exps.diff(moment(), "s");
          return remain <= 0;
        },

        getBonus: function(month){
          let b = {
            3: 1,
            6: 2,
            9: 4,
            12: 6
          };

          let bonus = b[month] ? b[month] : 0;

          return bonus;
        },

        getRole: function(code){
          if(code === "admin") return code;
          
          let length = code.length;

          switch(length){
            case 0: return "admin";
            case 1: return "house";
            case 3: return "company";
            case 5: return "general";
            case 7: return "agency";
            case 9: return "player";
          }

          return "player";
        },

        propGroupToName: function(propId){
          propId = parseInt(propId);

          switch(propId){
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
              return "2d";
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
              return "3d";
            case 11:
            case 12:
            case 13:
              return "4d";
            case 14:
            case 15:
            case 16:
              return "da";
            case 17:
            case 18:
            case 19:
              return "dx";
          }

          return "";
        },
    }
}();

export { Utilities };